import React from 'react';
import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';

const GuestGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = useSelector((state: ApplicationState) => state.app?.token);
  const user = useSelector((state: ApplicationState) => state.app?.appUser);
  const hasTokenInStorage = !!localStorage.getItem('access_token');

  if ((token && !!user) || hasTokenInStorage) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};

export default GuestGuard;
